import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Card, FormText } from 'src/components'
import { IDataForm } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/CardPagaloForm'

const form: IInputDataSimple[] = [
  { name: 'name', type: 'text', label: 'Nombre' },
  { name: 'phone', type: 'phone', label: 'Teléfono' },
  { name: 'nit', type: 'text', label: 'NIT' },
  { name: 'dpi', type: 'text', label: 'DPI' },
]

export const PagaloAdmin = ({ data, onChange }: IDataForm) => {
  return (
    <Card white title={'Administración'}>
      <Row>
        {form.map(({ name, type, label }) => (
          <Col key={name} xl={6} lg={6} md={6} sm={12} xs={12}>
            <FormText
              label={label}
              value={data[name]}
              name={name}
              required
              type={type}
              onChange={onChange}
            />
          </Col>
        ))}
      </Row>
    </Card>
  )
}
